// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/login/Login'
import clearRedis from '../components/login/clearRedis'
import Index from '../components/index/Index'
import Home from '../components/index/Home'
import Set from '../components/set/set'
import oa from '../components/oa/oa'
import JieSuan from '../components/account/JieSuan'
import OrderNew from '../components/testorder/cstagreement/Order'
import Order4Supply from '../components/testorder/cstagreement/Order4Supply'
import WaitauditNew from '../components/workflow/waitaudit/Waitaudit'
import hospitalaudit from '../components/workflow/hospital/auditList'
import LXstoreList from '../components/workflow/waitaudit/LXstoreList'

import Store from '../components/testorder/cstagreement/Store'
import CustomService from '../components/testorder/cstagreement/CustomService'
import Buy from '../components/testorder/cstagreement/Buy'
import Machining from '../components/testorder/cstagreement/Machining'
import ManageTenantList from '../components/sysmanage/managgetenant/ManageTenantList'
import ParameterMaintainList from '../components/sysmanage/parametermaintain/ParameterMaintainList'
import appupdateList from '../components/sysmanage/parametermaintain/appupdateList'
import ShouQuanBrandList from '../components/sysmanage/shouquanbrand/ShouQuanBrandList'

const EmployeeList = () => import("@/components/set/employee/EmployeeList")
const DeptList = () => import("@/components/set/dept/DeptList")
const JxcstoreList = () => import("@/components/set/jxcstore/JxcstoreList")
const JxcgoodscategoryList = () => import("@/components/set/jxcgoodscategory/JxcgoodscategoryList")
const JxcgoodscategorySupply = () => import("@/components/set/jxcgoodscategory/JxcgoodscategorySupply")
const JxcgooddetailList = () => import("@/components/set/jxcgooddetail/JxcgooddetailList")
const JxcgooddetailSupply = () => import("@/components/set/jxcgooddetail/JxcgooddetailSupply")
const ExternaldeptKeHu = () => import("@/components/set/externaldept/ExternaldeptKeHu")
const ExternaldeptJingXiao = () => import("@/components/set/externaldept/ExternaldeptJingXiao")
const ExternaldeptGongYing = () => import("@/components/set/externaldept/ExternaldeptGongYing")
const GoodsPriceCost = () => import("@/components/set/goodsprice/GoodsPriceCost")
const GoodsPriceSale = () => import("@/components/set/goodsprice/GoodsPriceSale")
const GoodsPriceWarehouse = () => import("@/components/set/goodsprice/GoodsPriceWarehouse")
const GoodsPriceJingXiao = () => import("@/components/set/goodsprice/GoodsPriceJingXiao")
const SaleFavourList = () => import("@/components/set/salefavour/SaleFavourList")
const SalefreightList = () => import("@/components/set/salefreight/SalefreightList")
const AuthoritySet = () => import("@/components/set/authorityset/AuthoritySet")
const InforclassList = () => import("@/components/oa/inforclass/InforclassList")
const AppHomeConfigureList = () => import("@/components/oa/AppHomeConfigure/AppHomeConfigureList")
const RechargeRecordList = () => import("@/components/set/recharge/rechargeRecordList")
const BroadcastManage = () => import("@/components/set/appimgmanage/BroadcastManage")
const BestSellersManage = () => import("@/components/set/appimgmanage/BestSellersManage")
const Upperandlower = () => import("@/components/set/upperandlower/Upperandlower.vue")
const OpLogList = () => import("@/components/set/oplog/OpLogList.vue")
const OppriceLogList = () => import("@/components/set/oplog/OppriceLogList.vue")
const LoginLogList = () => import("@/components/set/oplog/LoginLogList.vue")
const PuhuoCompute = () => import("@/components/testorder/salecontract/PuhuoCompute.vue")
const OrderList = () => import("@/components/set/oplog/OrderList.vue")
const PriceLevelManage = () => import("@/components/set/pricelevelmanage/PriceLevelManage.vue")
const Themes = () => import("@/components/theme/Themes.vue")
const SalecollageList = () => import("@/components/set/salecollage/SalecollageList.vue")
const LensLabelTemplateList = () => import("@/components/set/lensLabelTemplate/LensLabelTemplateList")
const certList = () => import("@/components/set/cert/certList.vue")
const SaleContractList = () => import("@/components/testorder/salecontract/SaleContractList.vue")
const Puhuoset = () => import("@/components/testorder/salecontract/Puhuoset.vue")
const CstagreementList = () => import("@/components/testorder/cstagreement/CstagreementList.vue")
const StoreDetailListSupply = () => import("@/components/account/StoreDetailListSupply")
const StoreDetailListSell = () => import("@/components/account/StoreDetailListSell")
const StorageMoney = () => import("@/components/testorder/warehouse/StorageMoney")
const StoreDetailListCustomer = () => import("@/components/account/StoreDetailListCustomer")
const StoreDetailListRecharge = () => import("@/components/account/StoreDetailListRecharge")
const StoreDetailListJiXiao = () => import("@/components/account/StoreDetailListJiXiao")
const UniqueCodeCreate = () => import("@/components/testorder/warehouse/UniqueCodeCreate")
const goodsCost = () => import("@/components/account/goodsCost")
const VoucherTJ = () => import("@/components/voucher/VoucherTJ")
const YinfuTJ = () => import("@/components/voucher/YinfuTJ")
const StoreDetailListSeed = () => import("@/components/account/StoreDetailListSeed")
const SupplyProfit = () => import("@/components/profit/SupplyProfit")
const BuyContractList = () => import("@/components/testorder/salecontract/BuyContractList")
const PuHuoTongJi = () => import("@/components/account/PuHuoTongJi")

const XianPianApp = () => import("@/components/testorder/cstagreement/XianPianApp.vue")
const ZuoYouYanApp = () => import("@/components/testorder/cstagreement/ZuoYouYanApp.vue")
const HsZuoYouYanApp = () => import("@/components/testorder/cstagreement/HsZuoYouYanApp.vue")
const HsXianPianApp = () => import("@/components/testorder/cstagreement/HsXianPianApp.vue")
const HsTuiHuoXianPianApp = () => import("@/components/testorder/cstagreement/HsTuiHuoXianPianApp.vue")
const HsTuiHuoXianPianAppch = () => import("@/components/testorder/cstagreement/HsTuiHuoXianPianAppch.vue")
const HsTuiHuoJingJiaApp = () => import("@/components/testorder/cstagreement/HsTuiHuoJingJiaApp.vue")
const HsScanlens= () => import("@/components/testorder/cstagreement/HsScanlens.vue")
const HsScanlensV2= () => import("@/components/testorder/cstagreement/HsScanlensV2.vue")
const HsScanlensReturn= () => import("@/components/testorder/cstagreement/HsScanlensReturn.vue")
const emptyVue = () => import("@/components/testorder/cstagreement/emptyVue.vue")
const checkToken = () => import("@/components/login/checkToken.vue")
const TestAPI = () => import("@/components/common/TestAPI.vue")
const List2Dismens = () => import("@/components/testorder/buyagreement/List2Dismens")
const OSSIempower  = () => import("@/components/set/pricelevelmanage/OSSIempower.vue")
const SalePricegroupList = () => import("@/components/set/salefavour/SalePricegroupList")
const SalePriceLensList = () => import("@/components/set/salefavour/SalePriceLensList")

const LensQuickOrder = () => import("@/components/lens/LensQuickOrder")
const AirdocMachine = () => import("@/components/airdoc/AirdocMachine")
const AirdocOrder= () => import("@/components/airdoc/AirdocOrder")
const AirdocUselog= () => import("@/components/airdoc/AirdocUselog")

const Reimbursement = () => import("@/components/oa/payform/Reimbursement")
const Payments = () => import("@/components/oa/payform/Payments")
const OrderBack = () => import("@/components/oa/payform/OrderBack")
const PayAccount = () => import("@/components/oa/payform/PayAccount")
const Paymethod = () => import("@/components/oa/payform/PayMethod")
const WorkflowSet = () => import("@/components/set/workflow/WorkflowSet")
const PayFeeType = () => import("@/components/set/workflow/PayFeeType")

const FrameProductList = () => import("@/components/frameproduct/product/FrameProductList")

Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  mode: "hash",
  // base: '/hot/', //2018-6-30  不然打包之后部署tomcat如果无法访问路由，加上这句。hot是tomcat中的根路径所在文件夹名，也可以修改。
  routes: [
    {
      name: "index", path: '/index', component: Index, meta: {requiresAuth: true},
      children: [
        {path: "", component: Home},
        {path: 'home', component: Home, name: 'home'},
        {path: 'clearredis', component: clearRedis, name: 'clearredis'},
        {name: "SupplyProfit", component: SupplyProfit, path: "SupplyProfit", meta: {requiresSupplyAuth: true}},//供应商利润页面
        {path: 'waitaudlt', component: WaitauditNew, name: 'waitaudlt'},
        {path: 'hospitalaudit',component: hospitalaudit, name: 'hospitalaudit'},
        {path: 'LXstoreList', component: LXstoreList, name: 'LXstoreList'},
        {
          path: 'JieSuan', component: JieSuan, name: 'JieSuan', children: [
            {name: "CstagreementList", component: CstagreementList, path: "CstagreementList"},
            {
              name: "StoreDetailListSupply",
              component: StoreDetailListSupply,
              path: "StoreDetailListSupply"
            },
            {name: "StoreDetailListSell", component: StoreDetailListSell, path: "StoreDetailListSell"},
            {name: "StorageMoney", component: StorageMoney, path: "StorageMoney"},
            {
              name: "StoreDetailListCustomer",
              component: StoreDetailListCustomer,
              path: "StoreDetailListCustomer"
            },
            {
              name: "StoreDetailListRecharge",
              component: StoreDetailListRecharge,
              path: "StoreDetailListRecharge"
            },
            {
              name: "StoreDetailListJiXiao",
              component: StoreDetailListJiXiao,
              path: "StoreDetailListJiXiao"
            },
            {name: "goodsCost", component: goodsCost, path: "goodsCost"},
            {name: "VoucherTJ", component: VoucherTJ, path: "VoucherTJ"},
            {name: "YinfuTJ", component: YinfuTJ, path: "YinfuTJ"},
            {name: "StoreDetailListSeed", component: StoreDetailListSeed, path: "StoreDetailListSeed"},
            {name: "SaleContractList", component: SaleContractList, path: "SaleContractList"},
            {name: "PuHuoTongJi", component: PuHuoTongJi, path: "PuHuoTongJi"},
          ]
        },
        {
          path: 'set', component: Set, name: 'set', children: [
            {path: "EmployeeList", component: EmployeeList, name: "EmployeeList"},
            {path: "JxcstoreList", component: JxcstoreList, name: "JxcstoreList"},
            {path: "DeptList", component: DeptList, name: "DeptList"},
            {path: "JxcgoodscategoryList", component: JxcgoodscategoryList, name: "JxcgoodscategoryList"},
            {path: "JxcgoodscategorySupply", component: JxcgoodscategorySupply, name: "JxcgoodscategorySupply"},
            {path: "JxcgooddetailList", component: JxcgooddetailList, name: "JxcgooddetailList"},
            {path: "JxcgooddetailSupply", component: JxcgooddetailSupply, name: "JxcgooddetailSupply"},
            {path: "ExternaldeptKeHu", component: ExternaldeptKeHu, name: "ExternaldeptKeHu"},
            {path: "ExternaldeptJingXiao", component: ExternaldeptJingXiao, name: "ExternaldeptJingXiao"},
            {path: "ExternaldeptGongYing", component: ExternaldeptGongYing, name: "ExternaldeptGongYing"},
            {path: "GoodsPriceCost", component: GoodsPriceCost, name: "GoodsPriceCost"},
            {path: "BuyContractList", component: BuyContractList, name: "BuyContractList"},
            {path: "GoodsPriceSale", component: GoodsPriceSale, name: "GoodsPriceSale"},
            {path: "GoodsPriceWarehouse", component: GoodsPriceWarehouse, name: "GoodsPriceWarehouse"},
            {path: "GoodsPriceJingXiao", component: GoodsPriceJingXiao, name: "GoodsPriceJingXiao"},
            {path: "SaleFavourList", component: SaleFavourList, name: "SaleFavourList"},
            {path: "SalefreightList", component: SalefreightList, name: "SalefreightList"},
            {name: "Puhuoset", component: Puhuoset, path: "Puhuoset"},
            {path: "AuthoritySet", component: AuthoritySet, name: "AuthoritySet"},
            {path: "AppHomeConfigureList", component: AppHomeConfigureList, name: "AppHomeConfigureList"},
            {path: "BroadcastManage", component: BroadcastManage, name: "BroadcastManage"},
            {path: "Upperandlower", component: Upperandlower, name: "Upperandlower"},
            {path: "BestSellersManage", component: BestSellersManage, name: "BestSellersManage"},
            {path: "RechargeRecordList", component: RechargeRecordList, name: "RechargeRecordList"},
            {path: "OpLogList", component: OpLogList, name: "OpLogList"},
            {path: "OppriceLogList", component: OppriceLogList, name: "OppriceLogList"},
            {path: "LoginLogList", component: LoginLogList, name: "LoginLogList"},
            {path: "SaleContractList", component: SaleContractList, name: "SaleContractList"},
            {path: "OrderList", component: OrderList, name: "OrderList"},
            {path: "PriceLevelManage", component: PriceLevelManage, name: "PriceLevelManage"},
            {path: "SalecollageList", component: SalecollageList, name: "SalecollageList"},
            {path: "OSSIempower", component: OSSIempower, name: "OSSIempower"},
            {path: 'Themes', component: Themes, name: 'Themes'},
            {path: 'certList', component: certList, name: 'certList'},
            {path: 'SalePricegroupList', component: SalePricegroupList, name: 'SalePricegroupList'},
            {path: 'SalePriceLensList', component: SalePriceLensList, name: 'SalePriceLensList'},
            {path: 'AirdocMachine', component: AirdocMachine, name: 'AirdocMachine'},
            {path: 'AirdocOrder', component: AirdocOrder, name: 'AirdocOrder'},
            {path: 'AirdocUselog', component: AirdocUselog, name: 'AirdocUselog'},
            {path: 'FrameProductList', component: FrameProductList, name: 'FrameProductList'},
            {path: 'UniqueCodeCreate', component: UniqueCodeCreate, name: 'UniqueCodeCreate'},
            {path: 'sethospitalaudit',component: hospitalaudit, name: 'sethospitalaudit'},
            {path: 'ManageTenantList', component: ManageTenantList, name: 'ManageTenantList'},
            {path: 'ParameterMaintainList', component: ParameterMaintainList, name: 'ParameterMaintainList'},
            {path: 'appupdateList', component: appupdateList, name: 'appupdateList'},
            {path: 'ShouQuanBrandList', component: ShouQuanBrandList, name: 'ShouQuanBrandList'},
                        {path: 'LensLabelTemplateList', component: LensLabelTemplateList, name: 'LensLabelTemplateList'},
          ]
        },
        {
          path: 'oa', component: oa, name: 'oa', children: [
            {path: "Reimbursement", component: Reimbursement, name: "Reimbursement"},
            {path: "Payments", component: Payments, name: "Payments"},
            {path: "OrderBack", component: OrderBack, name: "OrderBack"},
            {path: "PayAccount", component: PayAccount, name: "PayAccount"},
            {path: 'WorkflowSet', component: WorkflowSet, name: 'WorkflowSet'},
            {path: "InforclassList", component: InforclassList, name: "InforclassList"},
            {path:'Paymethod',component:Paymethod,name:'Paymethod'},
            {path:'PayFeeType',component:PayFeeType,name:'PayFeeType'}
          ]
        },
        {path: 'testorder', component: OrderNew, name: 'testorder'},
        {path: 'Order4Supply', component: Order4Supply, name: 'Order4Supply'},
        {path: 'customservice', component: CustomService, name: 'customservice'},
        {path: 'machining', component: Machining, name: 'machining'},
        {path: 'store', component: Store, name: 'store'},
        {path: 'buy', component: Buy, name: 'buy'},
        // {path: 'datacenter', component: DataCenter, name: 'DataCenter'},
        // {path: 'RunDataList', component: RunDataList, name: 'RunDataList'},
       /* {path: 'Themes', component: Themes, name: 'Themes'},*/
      ]
    },
    {name: "login", path: '/login', component: Login},
    {name: "loginsupply", path: '/loginsupply', component: Login},
    {name: "PuhuoCompute", path: '/PuhuoCompute', component: PuhuoCompute},
    {name: "xianpianapp", path: '/app/XianPian', component: XianPianApp, meta: {requiresWebAuth: true}},
    {name: "zuoyouyanapp", path: '/app/ZuoYouYanApp', component: ZuoYouYanApp, meta: {requiresWebAuth: true}},
    {name: "HsXianPianApp", path: '/app/HsXianPianApp', component: HsXianPianApp, meta: {requiresWebAuth: true}},
    {name: "HsZuoYouYanApp", path: '/app/HsZuoYouYanApp', component: HsZuoYouYanApp, meta: {requiresWebAuth: true}},
    {
      name: "HsTuiHuoXianPianApp",
      path: '/app/HsTuiHuoXianPianApp',
      component: HsTuiHuoXianPianApp,
      meta: {requiresWebAuth: true}
    },
    {
      name: "HsTuiHuoXianPianAppch",
      path: '/app/HsTuiHuoXianPianAppch',
      component: HsTuiHuoXianPianAppch,
      meta: {requiresWebAuth: true}
    },
    {
      name: "HsTuiHuoJingJiaApp",
      path: '/app/HsTuiHuoJingJiaApp',
      component: HsTuiHuoJingJiaApp,
      meta: {requiresWebAuth: true}
    },
    {
      name: "HsScanlens",
      path: '/app/HsScanlens',
      component: HsScanlens,
      meta: {requiresWebAuth: true}
    },
    {
      name: "HsScanlensV2",
      path: '/app/HsScanlensV2',
      component: HsScanlensV2,
      meta: {requiresWebAuth: true}
    },
    {
      name: "HsScanlensReturn",
      path: '/app/HsScanlensReturn',
      component: HsScanlensReturn,
      meta: {requiresWebAuth: true}
    },
    {
      name: "LensQuickOrder",
      path: '/app/LensQuickOrder',
      component: LensQuickOrder,
      meta: {requiresWebAuth: true}
    },
    {
      name: "emptyVue",
      path: '/app/emptyVue',
      component: emptyVue,
      meta: {requiresWebAuth: true}
    },
    {
      name: "default", path: '/', component: Index, meta: {requiresAuth: true},
      children: [
        {path: "", component: Home},
      ]
    },
    {
      name: "testapi", path: '/testapi', component: TestAPI, meta: {requiresAuth: true}
    },
    {
      name: "List2Dismens", path: '/dismens', component: List2Dismens, meta: {requiresAuth: false}
    },

  ]
})

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => record.meta.requiresSupplyAuth)) {
    let tokenmodel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
    if (localStorage.getItem("hpapi_token") && tokenmodel.loginfrom == "supply") {
      next()
    } else {
      next({
        name: 'loginsupply',
        params: {redirect: to.fullPath}
      })
    }
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    //let tokenmodel = JSON.parse(localStorage.getItem("hpapi_tokenModel"));
    // 这个判断先去掉，单点登录跳转过来时，还没取到tokenmodel：
    // tokenmodel.loginfrom == "pc"
    if (localStorage.getItem("hpapi_token") || to.query.token) {
      next()
    } else if (localStorage.getItem("hpapi_token") == null) {
      next({
        name: 'login',
        params: {redirect: to.fullPath}
      })
    } else {
      next({
        name: 'login',
        params: {redirect: to.fullPath}
      })
    }
  } else if (to.matched.some(record => record.meta.requiresWebAuth)) {
    if (localStorage.getItem("hpweb_token")|| to.query.token) {
      next()
    }
  } else {
    next()
  }
})

//返回router对象
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js